import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PaymentLink {
  advanceOption: any;
  id: string;
  options: any;
  organizationId: string;
  products: any;
  shortcode: string;
  type: string;
}

interface PaymentLinkState {
  paymentLinkArray: PaymentLink[];
}

const initialState: PaymentLinkState = {
  paymentLinkArray: [],
};

// @ts-ignore
export const PaymentLinkSlice = createSlice({
  name: "createPaymentLink",
  initialState,
  reducers: {
    saveCreatePaymentLink: (state, action: PayloadAction<PaymentLink>) => {
      state.paymentLinkArray.push(action.payload);
    },
    removePaymentLink: (state) => {
      state.paymentLinkArray = [];
    },
  },
});

export const { saveCreatePaymentLink, removePaymentLink } =
  PaymentLinkSlice.actions;
export default PaymentLinkSlice.reducer;
